import { FunctionComponent } from 'react'
import useStyles from '@/modules/Auth/components/ProfileCard/styles'
import { Box, Text, Avatar } from '@conexasaude/conexa-hero'

interface PropsProfileCard {
  className?: string
  name: string
  clinic: string
  photo: string
  type: string
}

const ProfileCard: FunctionComponent<PropsProfileCard> = ({
  className,
  name,
  clinic,
  photo,
  type,
}) => {
  const styles = useStyles()

  return (
    <div className={className} css={styles.profileCard}>
      <Box background="white">
        <div css={styles.itemsCard}>
          <div css={styles.avatarCard}>
            <Avatar alt={name} size="medium" src={photo} />
          </div>
          <div css={styles.textCard}>
            <Text
              renderAs="h5"
              css={styles.nameCard}
              className="text-capitalize"
            >
              {name.toLowerCase()}
            </Text>
            <div css={styles.clinicCard}>{clinic}</div>
            <div css={styles.boxPerfil}>
              <div css={styles.detailsCard}>Perfil:</div>
              <div>{type}</div>
            </div>
          </div>
        </div>
      </Box>
    </div>
  )
}

export default ProfileCard
